var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useRef, useEffect } from 'react';
import AnimateHeight from 'react-animate-height';
import { TagsButtons } from './buttons';
import { CHEVRON_DOWN_SVG } from '../assets';
import { useForceUpdate } from '../hooks';
var MAX_TAGS_SHOW = 50;
var DEFAULT_HEIGHT = 85;
export var TagFilter = function (props) {
    var _a = useState([]), tags = _a[0], setTags = _a[1];
    var _b = React.useState([]), filteredTags = _b[0], setFilterTags = _b[1];
    var _c = useState(''), filter = _c[0], setFilter = _c[1];
    var _d = useState(false), filterExpanded = _d[0], setFilterExpanded = _d[1];
    var _e = useState(false), showMore = _e[0], setShowMore = _e[1];
    var forceRender = useForceUpdate();
    var tagsButtonsRef = useRef(null);
    var moreButton = useRef(null);
    var tagView = useRef(null);
    useEffect(function () {
        setTags((props.tags || []).map(function (tag) {
            return __assign(__assign({}, tag), { sound_count: tag.sound_count || 0, selected: (props.selectedTags || []).includes(tag.id) || (props.selectedTags || []).includesLowercase(tag.name) });
        }).sort(function (tag1, tag2) {
            if (tag1.selected) {
                if (tag2.selected) {
                    return props.selectedTags.indexOf(tag1.id) - props.selectedTags.indexOf(tag2.id);
                }
                return -1;
            }
            else if (tag2.selected) {
                return 1;
            }
            return tag2.sound_count - tag1.sound_count;
        }).slice(0, MAX_TAGS_SHOW));
    }, [props.tags, props.selectedTags]);
    useEffect(function () {
        setFilterTags((filter.trim() != '') ? tags.filter(function (t) { return t.selected || t.name.toLowerCase().includes(filter.toLowerCase()); }) : tags);
    }, [tags, filter]);
    useEffect(function () {
        var _a, _b;
        forceRender();
        var height = ((_a = tagsButtonsRef.current) === null || _a === void 0 ? void 0 : _a.getClientHeight()) || 0;
        props.onHeightChange && props.onHeightChange(height + (((_b = moreButton.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0) + 27 + 8);
        if (height > (DEFAULT_HEIGHT) && !showMore) {
            setShowMore(true);
        }
        else if (showMore) {
            setShowMore(false);
        }
    }, [filteredTags]);
    return React.createElement("div", { className: 'TagFilter' },
        React.createElement("div", { className: "tags-section-container no-select", ref: tagView, style: tags.length === 0 ? { display: 'none' } : {} },
            React.createElement(AnimateHeight, { contentClassName: "AnimateHeight", className: 'animate-height-container', duration: 100, height: filterExpanded && tagsButtonsRef.current && moreButton.current
                    ? Math.max(DEFAULT_HEIGHT, tagsButtonsRef.current.getClientHeight() + moreButton.current.clientHeight + 27 + 8)
                    : DEFAULT_HEIGHT },
                React.createElement("div", { className: "tags-container tags" }, tags && (React.createElement(TagsButtons, { ref: tagsButtonsRef, buttons: filteredTags.map(function (tag) {
                        return {
                            buttonText: tag.name,
                            border: true,
                            buttonTextRight: tag.sound_count,
                            selected: tag.selected,
                            rightTextFontSize: '1.1rem',
                            variation: 'tag',
                            onClick: function () {
                                props.onTagClick(tag);
                            }
                        };
                    }) }))),
                React.createElement("div", { className: "more-button no-select " + (filterExpanded ? 'rotate' : ''), ref: moreButton, onClick: function () {
                        setFilterExpanded(!filterExpanded);
                    } }, showMore && React.createElement(React.Fragment, null,
                    React.createElement("span", null, filterExpanded ? 'SHOW LESS' : 'MORE'),
                    React.createElement("img", { src: CHEVRON_DOWN_SVG, alt: "Chevron" }))))));
};
//# sourceMappingURL=TagFilter.js.map